import React, { useEffect, useState } from "react";
import { Button } from "bootstrap-4-react/lib/components";
import { useNavigate } from "react-router-dom";
import LoaderSpinner from "../../common/Loader";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import BatchPagination from "../../batch/BatchPagination";
import { barCode, featureSubmodule, featureSubmodulePermission, inventoryManagement, numOfPage, orderManagement, permssionBulkUpload, permssionCreate, permssionEdit, permssionView, shipmentModule, SUBF_ADHOCBARCODEGENERATION, SUBF_LISTING } from "../../../constant";
import {
  getActiveIntegrations,
  getInventoryProductList,
} from "../../../store/actions/inventory.action";
import { checkPermission, renderTableRow } from "../../../config/utils";
import ViewImage from "../../common/ViewImage";
import SearchProduct from "./searchProduct";
import ActionItems from "../../common/showActions";
import { BulkUploadDialog } from "../../common/bulkUploadDialog";
import ProductListingFilter from "./ProductListingFilter";
import { InventoryProductBackDetails } from "../../../store/actions/employee";
import _ from "lodash";
import { Tooltip as WmsTooltip } from "react-tooltip";
import BarCodeGeneratePopup from "./BarCodePopup";
import moment from 'moment';
import { toast } from "react-toastify";
import { addToCart } from "../../../store/actions";
import PropTypes from "prop-types";
import DropshipListingModal from "../../incoming/product/DropshipListingModal";
import AddToMarketplaceModal from "./AddToMarketplaceModal";
import MarketplacePushWizard from "./MarketplacePushWizard";

const Inventory = (props) => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const {
    inventoryProductList,
    inventoryProductListStatus,
    activeIntegrations,
  } = useSelector((state) => state.InventoryManagement);
  const employeePermissions = useSelector((state) => state?.sidebar?.employeePermissions);
  const { cartItems } = useSelector((state) => state.shipment);
  const isDropshipEnabled = useSelector((state) => state?.dropshipReducer?.isDropshipEnabled);
  const dispatch = useDispatch();
  const [productList, setProductList] = useState([]);
  const [showDropshipModal, setShowDropshipModal] = useState(false);
  const [dropshipProduct, setDropshipProduct] = useState(null);
  let dataLoad = {
    pageIndex: 1,
    pageSize: 30,
    totalPages: 1,
    sortColumn: '',
    sortOrder: 'DESCENDING',
    searchKeyword: '',
    sellerIdList: [],
    companyIdList: [],
    showFilter: false,
  showSearch: true,
    totalRecords: 0,
    productCondition: 1, // 1 for Inventory
  }
  const [filterData, setfilterData] = useState({});
  const [selectedRecord, setSelectedRecord] = useState([]);
  const [showHideImageModal, setShowHideImageModal] = useState(false);
  const userDetails = useSelector((state) => state.auth.user);
  const { productPrevState } = useSelector((state) => state.employee);
  const [csvModalShow, setCsvModalShow] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [sellerList, setSellerList] = useState([]);
  const [allSellers, setAllSellers] = useState([]);
  const [showBarCodeModal, setShowBarCodeModal] = useState(false);
  const [barCodeRecord, setBarCodeRecord] = useState({});
  const [showProductTypeModal, setShowProductTypeModal] = useState(false);
  const [showMarketplaceModal, setShowMarketplaceModal] = useState(false);
  const [selectedProductForMarketplace, setSelectedProductForMarketplace] = useState(null);
  const [showPushWizard, setShowPushWizard] = useState(false);
  const [pushWizardMarketplaceIds, setPushWizardMarketplaceIds] = useState([]);
  const UserValue = useSelector((state) => state.auth.user);

  const handleFilterToggle = (key, value) => {
    setfilterData({ ...filterData, [key]: value });
  }

  useEffect(() => {
    if (inventoryProductListStatus === "pending") {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [inventoryProductListStatus]);

  useEffect(() => {
    if (inventoryProductList?.TotalRecords) {
      setfilterData({ ...filterData, totalRecords: inventoryProductList?.TotalRecords, totalPages: Math.ceil(inventoryProductList?.TotalRecords / filterData.pageSize) });
    }
    if (inventoryProductList?.listInventoryEntity) {
      setProductList(inventoryProductList?.listInventoryEntity);
    }
  }, [inventoryProductList]);

  useEffect(() => {
    if (!_.isEmpty(productPrevState)) {
      setfilterData({ ...filterData, ...productPrevState });
    } else {
      setfilterData(dataLoad);
    }
  }, []);

  const handleNavigateToProduct = (item, type = "") => {
    saveCurrentDetails();
    if (type) {
      navigate(`/inventory/${item}`, {
        state: {
          data: item,
          isEdit: type === "edit" ? true : false,
        },
      });
      return;
    }
    navigate(`/inventory/${item}`, {
      state: {
        data: item,
        isEdit: true,
      },
    });
  };

  useEffect(() => {
    if (!_.isEmpty(filterData)) {
      fetchProductList();
    }
  }, [filterData.pageSize, filterData.pageIndex, filterData.sortColumn, filterData.sortOrder]);

  const fetchProductList = () => {
    let data = {
      ...filterData,
      companyIdList: _.map(filterData.companyIdList, 'Id'),
      sellerIdList: _.map(filterData.sellerIdList, 'id'),
    }
    dispatch(getInventoryProductList(data));
  };

  const handleSortingColumn = (event, sortColumn) => {
    event.preventDefault();
    let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
    setfilterData({
      ...filterData,
      sortColumn: sortColumn,
      sortOrder: newSortOrder,
    });
  };

  const handleSearchFilter = (e, type) => {
    if (type === "clear") {
      let data = JSON.parse(JSON.stringify(dataLoad));
      data.showFilter = false;
      data.pageSize = filterData.pageSize
      setfilterData(data);
      dispatch(getInventoryProductList(data));
      setSellerList(allSellers);
      return;
    }
    fetchProductList();
    setfilterData({ ...filterData, pageIndex: 1 });
    dispatch(InventoryProductBackDetails({}));
  };


  const handleSortingClass = (columnName, isArrow = false) => {
    if (isArrow) {
      return filterData.sortColumn === columnName && filterData.sortOrder === "ASCENDING"
        ? "fa fa-arrow-up"
        : "fa fa-arrow-down";
    }
    return filterData.sortColumn === columnName ? "active sortBtn" : "sortColumn sortBtn";
  };

  const handleReset = () => {
    setfilterData({ ...filterData, searchKeyword: '' });
    let data = {
      pageIndex: filterData.currentPage,
      pageSize: filterData.pageSize,
      sortColumn: filterData.sortColumn,
      sortOrder: filterData.sortOrder,
      searchKeyword: "",
    };
    dispatch(getInventoryProductList(data));
  };

  const getActiveIntegrationList = () => {
    dispatch(getActiveIntegrations());
  };

  useEffect(() => {
    getActiveIntegrationList();
  }, []);

  useEffect(() => {
    if (activeIntegrations) {
      setGridData(activeIntegrations?.EntityList);
    }
  }, [activeIntegrations]);

  const saveCurrentDetails = () => {
    dispatch(InventoryProductBackDetails(filterData));
  }

  const handleHistoryPage = (item) => {
    saveCurrentDetails();
    navigate(`/inventory/history-${item.id}`, {
      state: {
        data: item,
        editable: false,
        type: 'product'
      },
    })
  };

  const setCurrentPagePagination = (value) => {
    setfilterData({ ...filterData, pageIndex: Number(value) });
  }
  const setTotalNumberOfPage = (value) => {
    setfilterData({ ...filterData, pageSize: Number(value), pageIndex: 1 });
  }

  const handleSearchText = (value) => {
    setfilterData({
      ...filterData,
      searchKeyword: value
    })
  };

  const handleBarCodeClick = (item) => {
    setBarCodeRecord(item);
    setShowBarCodeModal(true);
  }

  const handleMarketplaceClick = (item) => {
    setSelectedProductForMarketplace(item);
    setShowMarketplaceModal(true);
  }

  const handleMarketplaceSelection = (selectedMarketplaceIds) => {
    // v1: eBay is fully wired; Walmart shows a "coming soon" placeholder step.
    // Other channel_ids (Amazon=10001, Etsy=10004, Shopify=10002, TikTok=tbd)
    // are silently dropped by the wizard until their adapters land.
    const ids = (selectedMarketplaceIds || []).map(String);
    if (!ids.length) return;
    setPushWizardMarketplaceIds(ids);
    setShowPushWizard(true);
  }

  const handleAddToCartAction = (item) => {
    let items = _.cloneDeep(cartItems);
    let isExist = items.find((i) => i.id === item.id);
    if (!isExist) {
      let itemDetails = {
        ...item,
        MaxQuantity: item.quantity,
      };
      items.push(itemDetails);
      toast.success('Item Added in cart');
    } else {
      toast.info('Item already added in cart');
      return;
    }
    dispatch(addToCart(items));
  };

  return (
    <main>
      <div className="main__container">
        <div className="main__tile_heading cus-btn-include-sec">
          Inventory
          <div className="top_right_button_container">
            <div className="top_right_button_container">
              {checkPermission(inventoryManagement, SUBF_LISTING, permssionBulkUpload, featureSubmodulePermission, props.employeePermissions) && (
                <button
                  className="btn cus-seconday-bg-btn top-btn"
                  onClick={() => {
                    setCsvModalShow(true);
                  }}
                >
                  Bulk Upload
                </button>
              )}
              {checkPermission(inventoryManagement, SUBF_LISTING, permssionCreate, featureSubmodulePermission, props.employeePermissions) && (
                <Button
                  className="cus-seconday-bg-btn top-btn addNewProduct"
                  onClick={() => setShowProductTypeModal(true)}
                >
                  Add New Product
                </Button>
              )}
              <Button
                className="cus-seconday-bg-btn top-btn"
                onClick={() => navigate('/walmart-feeds')}
                style={{ backgroundColor: '#0071dc', borderColor: '#0071dc', color: '#fff' }}
              >
                Walmart Feeds
              </Button>
              {UserValue?.Value?.roleName !== 'Seller' && (
                <Button
                  className="cus-seconday-bg-btn top-btn FilterButton"
                  onClick={() => handleFilterToggle('showFilter', !filterData.showFilter)}
                >Filter</Button>
              )}


            </div>
          </div>
        </div>

        <SearchProduct
          showSearch={filterData.showSearch}
          searchTxt={filterData.searchKeyword}
          setSearchTxt={handleSearchText}
          handleReset={handleReset}
          handleSearchFilter={handleSearchFilter}
          placeHolderText="Search by Company, Seller, Product SKU or Product Name"
        />

        {filterData.showFilter && (
          <ProductListingFilter
            showFilter={filterData.showFilter}
            dispatch={dispatch}
            useSelector={useSelector}
            filterData={filterData}
            setfilterData={setfilterData}
            fetchProductList={fetchProductList}
            handleReset={handleSearchFilter}
            sellerList={sellerList}
            setSellerList={setSellerList}
            allSellers={allSellers}
            setAllSellers={setAllSellers}
          />
        )}
        {loader && <LoaderSpinner />}

        <div className="main_content cus-page-content-sec srch-pt0">
          <div className="main_content_table_history">
            <div className="tableFixHead incomingTbl">
              <Table
                className={`tableWide table-height cus-left-right-col-layout ${loader ? "disableTble" : ""
                  }`}
              >
                <thead className="tbl-btch">
                  <tr className="table-rw-batch">
                    <th>Thumbnail</th>
                    {userDetails?.Value?.roleName !== 'Seller' && (
                      <th width={'15%'}>Company / Seller Name</th>
                    )}
                    <th width={'12%'}>
                      <button
                        className={handleSortingClass("productSku")}
                        onClick={(e) => handleSortingColumn(e, "productSku")}
                        id="productSku"
                      >
                        Product SKU {" "}
                        <i
                          className={handleSortingClass("productSku", true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>
                    <th width={'15%'}>
                      <button
                        className={handleSortingClass("productName")}
                        onClick={(e) => handleSortingColumn(e, "productName")}
                        id="productName"
                      >
                        Product Name {" "}
                        <i
                          className={handleSortingClass("productName", true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>
                    <th width={'15%'} style={{ width: '15%' }}>Product Description</th>
                    <th width={'15%'}>
                      <button
                        className={handleSortingClass("consignmentType")}
                        onClick={(e) => handleSortingColumn(e, "consignmentType")}
                        id="consignmentType"
                      >
                        Type {" "}
                        <i
                          className={handleSortingClass("consignmentType", true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>
                    <th width="10%">
                      <button
                        className={handleSortingClass("quantity")}
                        onClick={(e) => handleSortingColumn(e, "quantity")}
                        id="quantity"
                      >
                        Quantity {" "}
                        <i
                          className={handleSortingClass("quantity", true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>
                    <th>
                      <button
                        className={handleSortingClass("createdDate")}
                        onClick={(e) => handleSortingColumn(e, "createdDate")}
                        id="createdDate"
                      >
                        Created Date {" "}
                        <i
                          className={handleSortingClass("createdDate", true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>
                    <th width="15%" className="sticky">Action</th>
                  </tr>
                </thead>
                <tbody className="tbl-bt-body">
                  {inventoryProductListStatus === "success" && productList.map((item) => (
                    <tr key={item.id}>
                      <td>
                        {item.imageUrl && (
                          <button
                            className="thumbImg sortBtn"
                            onClick={() => {
                              setSelectedRecord(item);
                              setShowHideImageModal(!showHideImageModal);
                            }}
                          >
                            <img
                              src={item.imageUrl}
                              alt=""
                              style={{ height: "24px" }}
                            />
                          </button>
                        )}
                      </td>
                      {userDetails?.Value?.roleName !== 'Seller' && (
                        <td>{item.companySellerName}</td>
                      )}
                      <td>
                        <button
                          className="link sortBtn tableLink"
                          onClick={() =>
                            handleNavigateToProduct(item.id, "view")
                          }
                        >
                          {item.productSku}
                        </button>
                      </td>
                      <td>{item.productName}</td>
                      <td>{item.productDescription}</td>
                      <td>{item.consignmentType}</td>
                      <td>
                        {item.totalQuantity === 0 ? item.quantity : Number(item.totalQuantity)}
                        <>
                          <i className="fa fa-info-circle ml-2" aria-hidden="true" id={item.id}></i>
                          <WmsTooltip
                            anchorId={item.id}
                            id={item.id}
                            place="left"
                            data-tooltip-html={true}
                            className="tooltipWidth"
                          >
                            <div>Available Qty (Inventory) = {item.quantity}</div>
                            <div>Available Qty (Returns) = {item.totalQuantity === 0 ? 0 : Number(item.totalQuantity - item.quantity)}</div>
                          </WmsTooltip>
                        </>
                      </td>
                      <td>{moment(item.createdDate).format("MM-DD-YYYY | h:mm:ss A")}</td>
                      <td className="sticky">
                        {checkPermission(orderManagement, shipmentModule, permssionCreate, featureSubmodulePermission, employeePermissions) && (
                          <ActionItems
                            type={"icon"}
                            item={item}
                            handleAction={() =>
                              handleAddToCartAction(item)
                            }
                            iconContent="Add To Cart"
                            iconType="fa fa-cart-plus"
                          />
                        )}
                        {checkPermission(inventoryManagement, SUBF_LISTING, permssionView, featureSubmodulePermission, props.employeePermissions) && (
                          <ActionItems
                            type={"View"}
                            item={item}
                            handleAction={() =>
                              handleNavigateToProduct(item.id, "view")
                            }
                          />
                        )}
                        {checkPermission(inventoryManagement, SUBF_LISTING, permssionEdit, featureSubmodulePermission, props.employeePermissions) && (
                          <ActionItems
                            type={"Edit"}
                            item={item}
                            handleAction={() =>
                              handleNavigateToProduct(item.id, "edit")
                            }
                          />
                        )}

                        {checkPermission(barCode, SUBF_ADHOCBARCODEGENERATION, '', featureSubmodule, props.employeePermissions) && (
                          <i className="fa fa-qrcode mr-15 borderLessButton mt-1" id={`${item.id}+${'generateBarCode'}`} onClick={() => handleBarCodeClick(item)} aria-hidden="true"></i>
                        )}

                        <ActionItems
                          type={"History"}
                          item={item}
                          handleAction={() => handleHistoryPage(item)}
                        />

                        {isDropshipEnabled && (
                          <ActionItems
                            type={"icon"}
                            item={item}
                            handleAction={() => {
                              setDropshipProduct(item);
                              setShowDropshipModal(true);
                            }}
                            iconContent="List for Dropship"
                            iconType="fa fa-exchange"
                            icon="dropship"
                          />
                        )}

                        <ActionItems
                          type={"icon"}
                          item={item}
                          handleAction={() => handleMarketplaceClick(item)}
                          iconContent="Add to Marketplace"
                          iconType="fa fa-globe"
                          icon="marketplace"
                        />

                        <WmsTooltip
                          anchorId={`${item.id}+${'generateBarCode'}`}
                          content={'Generate Barcode'}
                          place="right"
                          className="tooltipWidth"
                        />
                      </td>
                    </tr>
                  ))}
                  {inventoryProductListStatus === "success" &&
                    productList.length === 0 &&
                    renderTableRow(10, "No Result Found...")}
                </tbody>
              </Table>
            </div>
            {csvModalShow && (
              <BulkUploadDialog
                onHide={() => setCsvModalShow(false)}
                show={csvModalShow}
                gridData={gridData}
                fetchProductList={fetchProductList}
              />
            )}

            <ViewImage
              title={"Product Image"}
              selectedRecord={selectedRecord}
              setShowHideImageModal={setShowHideImageModal}
              showHideImageModal={showHideImageModal}
            />
          </div>
        </div>
        <BatchPagination
          gridData={productList}
          totalRecords={filterData.totalRecords}
          numberOfPage={filterData.pageSize}
          numOfPage={numOfPage}
          loader={loader}
          currentPage={filterData.pageIndex}
          totalPages={filterData.totalPages}
          setCurrentPage={setCurrentPagePagination}
          setNumberOfPage={setTotalNumberOfPage}
        />
        <BarCodeGeneratePopup
          showPopup={showBarCodeModal}
          hidePopup={setShowBarCodeModal}
          barCodeRecord={barCodeRecord}
        />
      </div>

      {/* Product Type Chooser Modal */}
      <Modal show={showProductTypeModal} onHide={() => setShowProductTypeModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3" style={{ color: '#666' }}>Choose the type of product you want to create:</p>
          <div className="d-flex" style={{ gap: '12px' }}>
            <button
              className="btn flex-fill p-3 text-center"
              style={{ borderRadius: '8px', minHeight: '120px', border: '1px solid #ccc', backgroundColor: '#fff', color: '#333' }}
              onClick={() => {
                setShowProductTypeModal(false);
                handleNavigateToProduct(0);
              }}
            >
              <i className="fa fa-box fa-2x mb-2 d-block" aria-hidden="true"></i>
              <strong>General Product</strong>
              <p className="mb-0 mt-1" style={{ fontSize: '12px', color: '#888' }}>Standard inventory product</p>
            </button>
            <button
              className="btn flex-fill p-3 text-center"
              style={{ borderRadius: '8px', minHeight: '120px', border: '1px solid #0071dc', backgroundColor: '#fff', color: '#0071dc' }}
              onClick={() => {
                setShowProductTypeModal(false);
                navigate('/walmart-product/new');
              }}
            >
              <i className="fa fa-shopping-cart fa-2x mb-2 d-block" aria-hidden="true"></i>
              <strong>Walmart Product</strong>
              <p className="mb-0 mt-1" style={{ fontSize: '12px', color: '#888' }}>Create & submit to Walmart</p>
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {showDropshipModal && dropshipProduct && (
        <DropshipListingModal
          show={showDropshipModal}
          onHide={() => setShowDropshipModal(false)}
          product={dropshipProduct}
        />
      )}

      <AddToMarketplaceModal
        show={showMarketplaceModal}
        onHide={setShowMarketplaceModal}
        onMarketplaceSelect={handleMarketplaceSelection}
      />

      {showPushWizard && selectedProductForMarketplace && (
        <MarketplacePushWizard
          show={showPushWizard}
          onHide={() => setShowPushWizard(false)}
          product={selectedProductForMarketplace}
          selectedMarketplaceIds={pushWizardMarketplaceIds}
        />
      )}
    </main>
  );
};

Inventory.propTypes = {
  employeePermissions: PropTypes.array,
};

export default Inventory;
